import { useEffect } from 'react';
import { useQuery } from '@tanstack/react-query';
import { get } from './api';
import { DEFAULT_LIMITS, formatBytes, setUploadLimits, type UploadLimits } from '../uploads/store';

export type ClientSettings = { uploads: UploadLimits; weekCutoffDay?: number };

/** Non-secret settings the UI needs (upload limits etc.). Pushes upload limits into the queue. */
export function useClientSettings() {
  const q = useQuery({ queryKey: ['settings', 'client'], queryFn: () => get<ClientSettings>('/api/settings/client'), staleTime: 5 * 60_000 });
  useEffect(() => {
    if (q.data?.uploads) setUploadLimits(q.data.uploads);
  }, [q.data]);
  const uploads = q.data?.uploads ?? DEFAULT_LIMITS;
  return { ...q, uploads, limitText: `any file up to ${formatBytes(uploads.maxFileBytes)}` };
}
